import { init, config } from '@audiorecorder/client';
config.silero.url = '/worker_silero/dist/index.js';
config.url_worker_audio = '/worker_audio/dist/index.js';
//config.url_server = 'https://v2t.160worldmeet.net';
config.url_server = `${process.env.VUE_APP_TRANSCRIPT_HOST ||
  'http://localhost:3000'}`;
export { init };
